<template>
  <div class="m-container">
    <m_header></m_header>
    <div class="m-body">
<!--  跳转团队长结构图页面    -->
      <div class="m-to-salesmanStructure" @click="toPage('/salesman/salesmanStructure')"></div>
<!--  页面内容    -->
      <el-container class="m-title-head">
        <div class="m-title-left">
          <div class="m-title-t">业务人员管理与报告业绩统计</div>
          <span class="m-title-s">业务人员信息记录管理和报告业绩查询统计</span>
        </div>
        <div class="m-title-right" v-if="userType === '1'">
          <div v-for="item in cooperatorOpt" :key="item.value" style="margin: 0 20px 20px 0">
            <div class="top-option-item" :class="searchForm.cooperatorId === item.value ? 'top-option-this' : ''" @click="searchCooperator(item)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </el-container>
      <div class="m-table">
        <!--    查询功能部分    -->
        <div class="m-table-search-box">
          <div class="m-table-search-item">
            <div class="m-table-search-item-tit">查找团队长</div>
            <div>
              <el-form ref="searchForm" :model="searchForm" label-width="100px" inline size="small">
                <el-form-item label="队长电话:">
                  <el-input type="text" size="small" v-model="searchForm.phone" maxlength="11" placeholder="搜索电话" />
                </el-form-item>
                <el-form-item label="队长姓名:">
                  <el-input type="text" size="small" v-model="searchForm.userName"  placeholder="搜索姓名" />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="loadSearch(searchForm.type)">查询</el-button>
                  <el-button type="info" @click="resetSearch" plain>刷新</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="m-table-search-item">
            <div class="m-table-search-item-tit">查找业务员归属</div>
            <el-form ref="searchForm" label-width="100px" inline size="small">
              <el-form-item label="业务员电话:">
                <el-input type="text" size="small" v-model="salesmanPhone" maxlength="11" placeholder="业务员准确电话"/>
              </el-form-item>
              <el-form-item v-loading="isSalesmanTeamInfoLoading">
                <el-button type="primary" @click="loadSalesmanInfo">查看</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <!--    团队长、特派员选项    -->
        <el-container class="m-table-head">
          <div class="m-table-head" style="width: 100%;position: relative;">
            <div class="m-table-tips" v-if="userType === '1'">
              {{ selectedName }}
            </div>
            <div style="display: flex;">
              <div class="m-table-opt-item" :class="searchForm.type === '1' ? 'm-table-opt-this' : ''" @click="loadData('1')">
                团队长
              </div>
<!--              <div v-if="userType === '1'" class="m-table-opt-item" :class="searchForm.type === '2' ? 'm-table-opt-this' : ''" @click="loadData('2')">-->
<!--                特派员-->
<!--              </div>-->
              <div style="flex: 1;text-align: right;">
                <el-button v-if="searchForm.type === '1'" type="primary" size="small" @click="openDialog('1')">添加团队长</el-button>
<!--                <el-button v-if="userType === '1' && searchForm.type === '2'" type="warning" size="small" @click="openDialog('2')">添加特派员</el-button>-->
              </div>
            </div>
          </div>
        </el-container>
        <!--    列表    -->
        <el-table
          :data="list"
          v-loading="isLoading"
          style="width: 100%;margin-bottom: 20px;"
          border
          row-key="id"
          :expand-row-keys="expands"
          size="small">
          <el-table-column prop="phone" label="队长电话" align="center" width="240">
            <template slot-scope="scope">
              <div style="display: flex;">
                {{ scope.row.phone }}
                <el-tooltip class="item" effect="dark" content="变更团队长登录手机号" placement="bottom">
                  <el-button type="primary" size="mini" @click="openEditPhone(scope.row.id, scope.row.phone, 'team')" plain style="margin: 0 0 0 10px">变更</el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="查看变更团队长手机号历史" placement="bottom">
                  <el-button type="success" size="mini" @click="getEditPhoneLog(scope.row.id, 'team', scope.row.userName)" plain style="margin: 0 0 0 10px">历史</el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="队长姓名"></el-table-column>
          <el-table-column prop="idCard" label="队长身份证号" width="160"></el-table-column>
          <el-table-column prop="remarks" label="队长备注" width="160"></el-table-column>
          <el-table-column label="队长身份信息管理" width="200" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="变更团队长个人资料、密码信息" placement="bottom">
                <el-button type="primary" size="mini" @click="openForm(scope.row)" plain>变更资料</el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" content="查看变更团队长个人资料信息历史" placement="bottom">
                <el-button type="success" size="mini" @click="getSalesmanUpdateLog(scope.row.id, 'team')" plain>历史</el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="updateDate" label="修改时间"></el-table-column>
<!--          <el-table-column prop="fosterId" label="队长类型查看与变更" width="270" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              <span v-if="scope.row.fosterId === '' || scope.row.fosterId === null">-->
<!--                <el-tooltip class="item" effect="dark" content="团队长类型，查看团队长上下级关系" placement="bottom">-->
<!--                  <el-button type="warning" size="mini" @click="getParentTeamAndSonTeam(scope.row.id, scope.row.fosterId)" plain>初始团队长</el-button>-->
<!--                </el-tooltip>-->
<!--              </span>-->
<!--              <span v-else style="color: #67C23A;">-->
<!--                <el-tooltip class="item" effect="dark" content="团队长类型，查看团队长上下级关系" placement="bottom">-->
<!--                  <el-button type="warning" size="mini" @click="getParentTeamAndSonTeam(scope.row.id, scope.row.fosterId)" plain>育成团队长</el-button>-->
<!--                </el-tooltip>-->
<!--                <el-tooltip class="item" effect="dark" content="变更当前团队长育成业务员信息，变更时，从上级团队长所属业务员中重新选择" placement="bottom">-->
<!--                  <el-button type="danger" size="mini" @click="openReplaceTeam(scope.row)" plain style="margin-left: 10px;">变更</el-button>-->
<!--                </el-tooltip>-->
<!--                <el-tooltip class="item" effect="dark" content="查看变更育成业务员变更历史" placement="bottom">-->
<!--                  <el-button type="success" size="mini" @click="getReplaceTeamLog(scope.row.id)" plain style="margin-left: 10px;">历史</el-button>-->
<!--                </el-tooltip>-->
<!--              </span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column prop="createDate" label="添加时间"></el-table-column>
          <el-table-column label="业绩信息" width="110" align="center">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="查看当前团队长业绩信息以及所属育成团队长业绩总和，注意查询时间选择" placement="bottom">
                <el-button type="success" size="mini" @click="openAchievement(scope.row.id, scope.row.userName)" plain>业绩信息</el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <!--     业务员   ------------------------------------------------------------- ↓ -->
          <el-table-column type="expand" v-if="searchForm.type === '1'">
            <template slot-scope="props">
              <div class="salesman-box">
                <div class="salesman-bg">
                  <div class="salesman-head">
                    <div class="salesman-tit">业务员</div>
                    <div style="display: flex; align-items: center;justify-content: center;color: #ff4d51;">
                      <div style="width: 160px;text-align: right;">本团队内业务员电话查询：</div>
                      <div>
                        <el-input v-model="salesmanListContent" size="mini" maxlength="11" placeholder="请输入电话搜索"/>
                      </div>
                      <div style="margin-left: 20px;">
                        <el-button type="primary" size="mini" @click="loadSalesmanSearch(teamId)">查询</el-button>
                        <el-button type="info" plain size="mini" @click="refreshSalesmanData()">刷新</el-button>
                      </div>
                    </div>
                    <div>
                      <el-button type="primary" size="mini" @click="openSalesmanDialog(props.row.id, props.row.userName)">添加业务员</el-button>
                    </div>
                  </div>
<!--                  前端查询，只查当前页salesmanList.filter(data => !salesmanListContent || data.phone.toLowerCase().includes(salesmanListContent.toLowerCase()))-->
                  <el-table :data="salesmanList" v-loading="isSalesmanLoading" border size="mini">
                    <el-table-column prop="phone" label="业务员电话" align="center" width="240">
                      <template slot-scope="scope">
                        <div style="display: flex;">
                          {{ scope.row.phone }}
                          <el-tooltip class="item" effect="dark" content="变更业务员登录手机号" placement="bottom">
                            <el-button type="primary" size="mini" @click="openEditPhone(scope.row.id, scope.row.phone, 'salesman')" plain style="margin: 0 0 0 10px">变更</el-button>
                          </el-tooltip>
                          <el-tooltip class="item" effect="dark" content="查看变更业务员登录手机号历史" placement="bottom">
                            <el-button type="success" size="mini" @click="getEditPhoneLog(scope.row.id, 'salesman', scope.row.userName)" plain style="margin: 0 0 0 10px">历史</el-button>
                          </el-tooltip>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="userName" label="业务员姓名"></el-table-column>
                    <el-table-column prop="idCard" label="业务员身份证号" width="160"></el-table-column>
                    <el-table-column label="业务员身份信息管理" width="200" align="center">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="变更业务员个人资料、密码信息" placement="bottom">
                          <el-button type="primary" size="mini" @click="editSalesman(scope.row, props.row.id)" plain>变更资料</el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="查看变更业务员个人资料历史" placement="bottom">
                          <el-button type="success" size="mini" @click="getSalesmanUpdateLog(scope.row.id, 'salesman')" plain>历史</el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="createDate" label="添加时间"></el-table-column>
                    <el-table-column prop="updateDate" label="修改时间"></el-table-column>
<!--                    <el-table-column prop="fosterDate" label="育成时间"></el-table-column>-->
                    <el-table-column label="业绩信息" width="120" align="center">
                      <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="查看当前业务员业绩信息，注意查询时间选择" placement="bottom">
                          <el-button type="success" size="mini" @click="openSalesmanAchievement(scope.row.id, scope.row.teamId, scope.row.userName)" plain>业绩信息</el-button>
                        </el-tooltip>
                      </template>
                    </el-table-column>
<!--                    <el-table-column label="育成团队长" width="160" align="center">-->
<!--                      <template slot-scope="scope">-->
<!--                        <el-tooltip v-if="scope.row.toFosterId === '' || scope.row.toFosterId === null" class="item" effect="dark" content="将当前业务员提升为育成团队长" placement="bottom">-->
<!--                          <el-button type="primary" size="mini"-->
<!--                                     @click="openFoster(scope.row)" plain>升级团队长</el-button>-->
<!--                        </el-tooltip>-->
<!--                        <div v-else style="color: #67C23A;">育成团队长</div>-->
<!--                      </template>-->
<!--                    </el-table-column>-->
                  </el-table>
                  <el-pagination
                    @current-change="handleCurrentSalesmanChange"
                    :current-page="salesmanPageNo"
                    :page-size="10"
                    layout="total, prev, pager, next, jumper"
                    :total="salesmanTotal"
                    prev-text="上一页"
                    next-text="下一页">
                  </el-pagination>
                </div>
              </div>
            </template>
          </el-table-column>
          <!--     业务员  -------------------------------------------------------------- ↑ -->
          <el-table-column label="业务员管理" width="160" align="center" v-if="searchForm.type === '1'">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="管理当前团队长所属业务员信息" placement="bottom">
                <el-button type="primary" size="mini" @click="rowClick(scope.row)" plain>
                  业务员
                  <i class="el-icon-caret-bottom"></i>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          prev-text="上一页"
          next-text="下一页">
        </el-pagination>
      </div>
    </div>
    <!--  增加团队长，特派员，特派员只添加省级 1 团队长，2 特派员  -->
    <el-dialog :title="formTitle" :visible.sync="openState" @close='closeDialog' width="750px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="formLoading">
        <el-form :model="form" :rules="rules" ref="form" label-width="125px">
          <el-form-item label="联系电话: " prop="phone" v-if="!isEdit">
            <el-input v-model="form.phone" placeholder="输入联系电话" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="再次确认电话: " prop="checkPhone" v-if="!isEdit">
            <el-input v-model="form.checkPhone" placeholder="再次输入联系电话" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="姓名: " prop="userName">
            <el-input v-model="form.userName" placeholder="输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="再次确认姓名: " prop="checkUserName">
            <el-input v-model="form.checkUserName" placeholder="再次输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号: " prop="idCard">
            <el-input v-model="form.idCard" placeholder="输入身份证号"></el-input>
          </el-form-item>
          <el-form-item label="再次确认: " prop="checkIdCard">
            <el-input v-model="form.checkIdCard" placeholder="再次输入身份证号"></el-input>
          </el-form-item>
          <div v-if="isEdit" style="font-size: 12px; color: #ff4d51;margin-left: 130px;">不输入新密码则密码不会更换</div>
          <el-form-item label="初始密码: " prop="password">
            <el-input v-model="form.password"  placeholder="输入初始密码"></el-input>
          </el-form-item>
          <el-form-item label="再次确认密码: " prop="checkPassword">
            <el-input v-model="form.checkPassword"  placeholder="再次输入初始密码"></el-input>
          </el-form-item>
          <el-form-item label="备注说明: " prop="remarks">
            <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注说明"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  增加业务员  -->
    <el-dialog :title="salesmanTitle" :visible.sync="openSalesmanState" @close='closeSalesmanDialog' width="750px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="salesmanFormLoading">
        <el-form :model="salesmanForm" :rules="salesmanRules" ref="salesmanForm" label-width="125px">
          <el-form-item label="联系电话: " prop="phone" v-if="!isEdit">
            <el-input v-model="salesmanForm.phone" placeholder="输入联系电话" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="再次确认电话: " prop="checkPhone" v-if="!isEdit">
            <el-input v-model="salesmanForm.checkPhone" placeholder="再次输入联系电话" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="姓名: " prop="userName">
            <el-input v-model="salesmanForm.userName" placeholder="输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="再次确认姓名: " prop="checkUserName">
            <el-input v-model="salesmanForm.checkUserName" placeholder="再次输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号: " prop="idCard">
            <el-input v-model="salesmanForm.idCard" placeholder="输入身份证号"></el-input>
          </el-form-item>
          <el-form-item label="再次确认: " prop="checkIdCard">
            <el-input v-model="salesmanForm.checkIdCard" placeholder="再次输入身份证号"></el-input>
          </el-form-item>
          <div v-if="isEdit" style="font-size: 12px; color: #ff4d51;margin-left: 130px;">不输入新密码则密码不会更换</div>
          <el-form-item label="初始密码: " prop="password">
            <el-input v-model="salesmanForm.password"  placeholder="输入初始密码"></el-input>
          </el-form-item>
          <el-form-item label="再次确认密码: " prop="checkPassword">
            <el-input v-model="salesmanForm.checkPassword"  placeholder="再次输入初始密码"></el-input>
          </el-form-item>
          <el-form-item label="备注说明: " prop="remarks">
            <el-input v-model="salesmanForm.remarks" type="textarea" :rows="2" placeholder="输入备注说明"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openSalesmanState = false">取 消</el-button>
          <el-button type="primary" @click="submitSalesman()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  增加团队长，育成团队长  -->
<!--    <el-dialog title="升级为团队长" :visible.sync="openFosterState" @close='closeFosterDialog' width="650px" center :close-on-click-modal="false">-->
<!--      <div class="m-open-container" v-loading="fosterFormLoading">-->
<!--        <el-form :model="fosterForm" ref="fosterForm" label-width="125px">-->
<!--          <el-form-item label="联系电话: " prop="phone">-->
<!--            <el-input v-model="fosterForm.phone" readonly placeholder="输入初始密码"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="姓名: " prop="userName">-->
<!--            <el-input v-model="fosterForm.userName" readonly placeholder="输入初始密码"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="身份证号: " prop="idCard">-->
<!--            <el-input v-model="fosterForm.idCard" readonly placeholder="输入初始密码"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="初始密码: " prop="password">-->
<!--            <el-input v-model="fosterForm.password"  placeholder="输入初始密码"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="再次确认密码: " prop="checkPassword">-->
<!--            <el-input v-model="fosterForm.checkPassword"  placeholder="再次输入初始密码"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="备注说明: " prop="remarks">-->
<!--            <el-input v-model="fosterForm.remarks" type="textarea" :rows="2" placeholder="输入备注说明"></el-input>-->
<!--          </el-form-item>-->
<!--        </el-form>-->
<!--        <div slot="footer" class="dialog-foote" style="text-align: center;">-->
<!--          <el-button @click="openFosterState = false">取 消</el-button>-->
<!--          <el-button type="primary" @click="submitFoster()">确 定</el-button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </el-dialog>-->
    <!--  查看团队长业绩  -->
    <el-dialog :title="teamName + '-团队长业绩'" :visible.sync="openAchievementState" @close='closeAchievementDialog' width="950px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="openAchievementLoading">
        <div style="display: flex; flex-wrap: wrap;align-items: center; justify-content: center;">
          <el-form :model="achievementForm" ref="achievementForm" label-width="125px">
            <el-form-item label="查询时间:">
              <el-date-picker
                size="medium"
                v-model="achievementDateArr"
                @change="onDateChange"
                type="datetimerange"
                :default-time="['00:00:00','23:59:59']"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <el-button style="margin-left: 15px;" type="primary" @click="openAchievement(achievementForm.teamId, teamName)" size="medium">查 询</el-button>
            </el-form-item>
          </el-form>
          <div style="text-align: center;color: #ff4d51;font-size: 16px;margin-bottom: 4px;">未选择查询时间段时，数据均为累积总数</div>
        </div>
        <!--    业绩信息显示    -->
        <AchievementInfo :achievement="achievement"></AchievementInfo>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button type="primary" @click="openAchievementState = false">关 闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  查看团队长、业务员变更记录  -->
    <el-dialog title="资料变更历史" :visible.sync="updateLogState" @close='closeUpdateLogDialog' width="1000px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="updateLogLoading">
        <div>
          <el-table :data="updateLogList" border size="mini">
            <el-table-column prop="priUserName" label="姓名变更">
              <template slot-scope="scope">
                <div>变更前：{{ scope.row.priUserName }}</div>
                <div style="color: #1d62af">变更后：{{ scope.row.newUserName }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="newIdCard" label="身份证变更">
              <template slot-scope="scope">
                <div>变更前：{{ scope.row.priIdCard }}</div>
                <div style="color: #1d62af">变更后：{{ scope.row.newIdCard }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="newRemarks" label="备注变更">
              <template slot-scope="scope">
                <div>变更前：{{ scope.row.priRemarks }}</div>
                <div style="color: #1d62af">变更后：{{ scope.row.newRemarks }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="createDate" label="变更时间" width="150"></el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;padding: 20px 0 0 0;">
          <el-button type="primary" @click="updateLogState = false">关 闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  查看育成团队长变更来源记录  -->
    <el-dialog title="育成团队长变更历史" :visible.sync="replaceTeamLogState" @close='replaceTeamLogList = []' width="1000px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="replaceTeamLogLoading">
        <div>
          <el-table :data="replaceTeamLogList" border size="mini">
            <el-table-column prop="priPhone" label="变更信息">
              <template slot-scope="scope">
                <div style="display: flex;">
                  <div style="width: 50%;">
                    <div>变更前信息：</div>
                    <div>手机号：{{ scope.row.priPhone }}</div>
                    <div>姓名：{{ scope.row.priUserName }}</div>
                    <div>身份证：{{ scope.row.priIdCard }}</div>
                  </div>
                  <div style="width: 50%; color: #1d62af;">
                    <div>变更后信息：</div>
                    <div>手机号：{{ scope.row.newPhone }}</div>
                    <div>姓名：{{ scope.row.newUserName }}</div>
                    <div>身份证：{{ scope.row.newIdCard }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createDate" label="变更时间" width="150"></el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;padding: 20px 0 0 0;">
          <el-button type="primary" @click="replaceTeamLogState = false">关 闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  变更电话  -->
    <el-dialog title="变更电话" :visible.sync="openEditPhoneState" @close='closeEditPhoneDialog' width="650px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="editPhoneLoading">
        <el-form :model="editPhoneForm" ref="fosterForm" label-width="125px">
          <el-form-item label="id" prop="id" hidden>
            <el-input v-model="editPhoneForm.id" readonly placeholder="输入初始密码"></el-input>
          </el-form-item>
          <el-form-item label="原号码: " prop="id">
            <el-input v-model="editPhoneForm.priPhone" readonly placeholder="原号码" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="新号码: " prop="newPhone">
            <el-input v-model="editPhoneForm.newPhone"  placeholder="输入新号码" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="再次确认: " prop="checkPassword">
            <el-input v-model="editPhoneForm.checkNewPhone"  placeholder="再次输入新号码" maxlength="11"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openEditPhoneState = false">取 消</el-button>
          <el-button type="primary" @click="submitNewPhone()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  查看团队长、业务员变更电话记录  -->
    <el-dialog title="电话变更历史" :visible.sync="phoneLogState" @close='closePhoneLogDialog' width="400px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="phoneLogLoading">
        <div>
          <div style="text-align: center;margin-bottom: 10px;font-weight: bold;">
            {{ phoneLogName }}
          </div>
          <el-table :data="phoneLogList" border size="mini">
            <el-table-column prop="priPhone" label="电话变更">
              <template slot-scope="scope">
                <div>变更前：{{ scope.row.priPhone }}</div>
                <div style="color: #1d62af">变更后：{{ scope.row.newPhone }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="createDate" label="变更时间" width="150"></el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;padding: 20px 0 0 0;">
          <el-button type="primary" @click="phoneLogState = false">关 闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  变更育培队长  -->
    <el-dialog title="变更育成队长" :visible.sync="openReplaceState" @close='closeReplaceDialog' width="1100px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="openReplaceLoading">
        <div>
          <el-table :data="replaceSalesmanList.filter(data => !searchReplaceContent || data.phone.toLowerCase().includes(searchReplaceContent.toLowerCase()))" border size="mini">
            <el-table-column prop="phone" label="电话" width="200">
              <template slot="header" slot-scope="scope">
               <div style="display: flex;">
                 <div style="width: 30%;display: flex; align-items: center;justify-content: center;">电话:</div>
                 <div style="width: 70%;">
                   <el-input v-model="searchReplaceContent" size="mini" maxlength="11" placeholder="请输入电话搜索"/>
                 </div>
               </div>
              </template>
            </el-table-column>
            <el-table-column prop="userName" label="姓名"></el-table-column>
            <el-table-column prop="idCard" label="身份证号" width="160"></el-table-column>
            <el-table-column prop="createDate" label="添加时间" width="150"></el-table-column>
            <el-table-column label="选择" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="selectReplaceSalesman(scope.row)" plain>选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;padding: 20px 0 0 0;">
          <el-button type="primary" size="mini" @click="openReplaceState = false">关 闭</el-button>
        </div>
      </div>
      <!--  提交变更育培队长  -->
      <el-dialog title="变更育成队长信息" :visible.sync="openReplaceFormState" :append-to-body="true" :close-on-click-modal="false" @close='closeReplaceFormDialog' width="650px" center>
        <div class="m-open-container" v-loading="openReplaceFormLoading">
          <el-form :model="replaceForm" ref="replaceForm" label-width="125px">
            <el-form-item label="联系电话: " prop="phone">
              <el-input v-model="replaceForm.phone" readonly placeholder="输入初始密码"></el-input>
            </el-form-item>
            <el-form-item label="姓名: " prop="userName">
              <el-input v-model="replaceForm.userName" readonly placeholder="输入初始密码"></el-input>
            </el-form-item>
            <el-form-item label="身份证号: " prop="idCard">
              <el-input v-model="replaceForm.idCard" readonly placeholder="输入初始密码"></el-input>
            </el-form-item>
            <el-form-item label="登录密码: " prop="password">
              <el-input v-model="replaceForm.password"  placeholder="输入登录密码"></el-input>
            </el-form-item>
            <el-form-item label="再次确认密码: " prop="checkPassword">
              <el-input v-model="replaceForm.checkPassword"  placeholder="再次输入初始密码"></el-input>
            </el-form-item>
            <el-form-item label="备注说明: " prop="remarks">
              <el-input v-model="replaceForm.remarks" type="textarea" :rows="2" placeholder="输入备注说明"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-foote" style="text-align: center;">
            <el-button @click="openReplaceFormState = false">取 消</el-button>
            <el-button type="primary" @click="submitReplaceForm()">确 定</el-button>
          </div>
        </div>
      </el-dialog>
    </el-dialog>
    <!--  查看团队长上级团队长新信息以及下级信息  -->
    <el-dialog title="上下级团队长信息" :visible.sync="parentTeamState" @close='closeParentTeamDialog' width="800px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="parentTeamLoading">
        <div>
          <div class="parent-team-box">
            <div class="parent-team-team-t">上级团队长信息</div>
            <div class="parent-team-team-n">
              <div>电话：{{ parentTeam.phone }}</div>
              <div>姓名：{{ parentTeam.userName }}</div>
              <div>身份证号：{{ parentTeam.idCard }}</div>
            </div>
          </div>
          <div style="height: 1px; background-color: #ececec;margin: 20px 0 0 0"></div>
          <div class="parent-team-bott-t">下级团队长列表</div>
          <el-table :data="sonTeamList" border size="mini">
            <el-table-column prop="phone" label="电话"></el-table-column>
            <el-table-column prop="userName" label="姓名"></el-table-column>
            <el-table-column prop="idCard" label="身份证号"></el-table-column>
            <el-table-column prop="createDate" label="创建时间" width="150"></el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;padding: 20px 0 0 0;">
          <el-button type="primary" @click="parentTeamState = false">关 闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  查看业务员业绩  -->
    <el-dialog :title="salesmanName + '-业务员业绩'" :visible.sync="openAchSalesmanState" @close='closeAchSalesmanDialog' width="950px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="openAchSalesmanLoading">
        <div style="display: flex; flex-wrap: wrap;align-items: center; justify-content: center;">
          <el-form :model="achSalesmanForm" ref="achSalesmanForm" label-width="125px">
            <el-form-item label="查询时间:">
              <el-date-picker
                size="medium"
                v-model="achSalesmanDateArr"
                @change="onSalesmanDateChange"
                type="datetimerange"
                :default-time="['00:00:00','23:59:59']"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
              <el-button style="margin-left: 15px;" type="primary" @click="openSalesmanAchievement(achSalesmanForm.id, achSalesmanForm.teamId, salesmanName)" size="medium">查 询</el-button>
            </el-form-item>
          </el-form>
          <div style="text-align: center;color: #ff4d51;font-size: 16px;margin-bottom: 4px;">未选择查询时间段时，数据均为累积总数</div>
        </div>
        <!--    业绩信息显示    -->
        <div class="ach-box">
          <div class="ach-top ach-top-col">
            <div class="ach-item-money">总业绩额：<span class="num-color">{{ achSalesmanNum.allMoney }}</span> 元</div>
            <div class="ach-item-money">苹果系统业绩额：<span class="num-color">{{ achSalesmanNum.iosMoney }}</span> 元</div>
            <div class="ach-item-money">安卓系统业绩额：<span class="num-color">{{ achSalesmanNum.androidMoney }}</span> 元</div>
            <div class="ach-item">总用户人数：<span class="num-color">{{ achSalesmanNum.userNum }}</span> 人</div>
          </div>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button type="primary" @click="openAchSalesmanState = false">关 闭</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  业务员归属弹窗  -->
    <el-dialog title="业务员归属" :visible.sync="salesmanTeamInfo.phone !== ''" @close="salesmanTeamInfo.phone = ''" width="400px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="m-team-info">
          <div style="margin: 0 0 10px 0;">队长姓名：<span style="color: #ff4d51;font-weight: bold;">{{ salesmanTeamInfo.name }}</span></div>
          <div style="margin: 0 0 10px 0;">队长电话：<span style="color: #ff4d51;font-weight: bold;">{{ salesmanTeamInfo.phone }}</span></div>
          <div style="margin: 0 0 10px 0;" v-if="userType === '1'">
            所属地区：<span style="color: #ff4d51;font-weight: bold;">{{ salesmanTeamInfo.coopRemarks }}</span>
          </div>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button type="primary" @click="salesmanTeamInfo.phone = ''">关 闭</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AchievementInfo from './AchievementInfo'
export default {
  name: 'salesman',
  components: {
    AchievementInfo
  },
  data () {
    return {
      formTitle: '',
      salesmanPhone: '',
      selectedName: '',
      isSalesmanTeamInfoLoading: false,
      openState: false,
      formLoading: false,
      isEdit: false,
      isLoading: true,
      isSalesmanLoading: false,
      list: [],
      expands: [],
      salesmanList: [],
      salesmanListContent: '',
      salesmanPageNo: 1,
      salesmanTotal: 0,
      total: 0,
      teamId: '',
      userType: '',
      cooperatorOpt: [],
      updateLogState: false,
      updateLogLoading: false,
      updateLogList: [],
      searchForm: {
        userType: '',
        cooperatorId: '',
        phone: '',
        userName: '',
        type: '1',
        pageNo: 1
      },
      form: {
        id: '',
        parentId: '',
        phone: '',
        userName: '',
        idCard: '',
        password: '',
        checkPhone: '',
        checkUserName: '',
        checkIdCard: '',
        checkPassword: '',
        userType: '',
        remarks: ''
      },
      salesmanTitle: '',
      openSalesmanState: false,
      salesmanFormLoading: false,
      salesmanForm: {
        id: '',
        teamId: '',
        phone: '',
        userName: '',
        idCard: '',
        password: '',
        checkPhone: '',
        checkUserName: '',
        checkIdCard: '',
        checkPassword: '',
        remarks: ''
      },
      openFosterState: false,
      fosterFormLoading: false,
      fosterForm: {
        parentId: '',
        fosterId: '',
        toFosterId: '',
        phone: '',
        userName: '',
        idCard: '',
        password: '',
        checkPassword: '',
        userType: '',
        remarks: ''
      },
      rules: {
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ]
      },
      salesmanRules: {
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ]
      },
      salesmanTeamInfo: {
        phone: '',
        name: '',
        coopRemarks: ''
      },
      // 业绩
      openAchievementLoading: false,
      openAchievementState: false,
      achievementForm: {
        teamId: '',
        startDate: '',
        endDate: ''
      },
      achievementDateArr: [],
      teamName: '',
      salesmanName: '',
      achievement: {
        fosterAllMoney: 0,
        fosterNum: 0,
        fosterSalesmanNum: 0,
        fosterUserNum: 0,
        teamAllMoney: 0,
        teamSalesmanNum: 0,
        teamUserNum: 0
      },
      // 变更手机号
      openEditPhoneState: false,
      editPhoneLoading: false,
      editPhoneForm: {
        id: '',
        type: '',
        priPhone: '',
        newPhone: '',
        checkNewPhone: ''
      },
      phoneLogState: false,
      phoneLogLoading: false,
      phoneLogName: '',
      phoneLogList: [],
      // 替换育成团队长
      openReplaceState: false,
      openReplaceLoading: false,
      searchReplaceContent: '',
      replaceSalesmanList: [],
      openReplaceFormState: false,
      openReplaceFormLoading: false,
      replaceForm: {
        id: '',
        salesmanId: '',
        logPhone: '',
        logUserName: '',
        logIdCard: '',
        phone: '',
        userName: '',
        idCard: '',
        password: '',
        checkPassword: '',
        remarks: ''
      },
      replaceTeamLogState: false,
      replaceTeamLogLoading: false,
      replaceTeamLogList: [],
      parentTeamState: false,
      parentTeamLoading: false,
      parentTeam: {
        phone: '',
        userName: '',
        idCard: ''
      },
      sonTeamList: [],
      // 查看业务员业绩
      openAchSalesmanState: false,
      openAchSalesmanLoading: false,
      achSalesmanDateArr: [],
      achSalesmanNum: {
        allMoney: '',
        iosMoney: '',
        androidMoney: '',
        userNum: ''
      },
      achSalesmanForm: {
        id: '',
        teamId: '',
        startDate: '',
        endDate: ''
      }
    }
  },
  methods: {
    toPage (path) {
      let cooperatorId = ''
      if (this.userType === '1') {
        cooperatorId = this.searchForm.cooperatorId
      }
      this.$router.push({path: path + '?cooperatorId=' + cooperatorId})
    },
    // 关闭业务员业绩弹窗清空
    closeAchSalesmanDialog () {
      this.achSalesmanForm = {
        id: '',
        teamId: '',
        startDate: '',
        endDate: '',
        allMoney: '',
        userNum: ''
      }
      this.achSalesmanNum = {
        allMoney: '',
        userNum: ''
      }
      this.achSalesmanDateArr = []
    },
    // 上下级团队长信息清空
    closeParentTeamDialog () {
      this.parentTeam = {
        phone: '',
        userName: '',
        idCard: ''
      }
      this.sonTeamList = []
    },
    // 选择要提交的变更来源业务员
    selectReplaceSalesman (row) {
      let _this = this
      _this.replaceForm.salesmanId = row.id
      _this.replaceForm.phone = row.phone
      _this.replaceForm.userName = row.userName
      _this.replaceForm.idCard = row.idCard
      _this.openReplaceFormState = true
    },
    // 关闭变更育成团队长弹窗清空
    closeReplaceDialog () {
      this.replaceSalesmanList = []
      this.searchReplaceContent = ''
      this.replaceForm = {
        id: '',
        salesmanId: '',
        logPhone: '',
        logUserName: '',
        logIdCard: '',
        phone: '',
        userName: '',
        idCard: '',
        password: '',
        checkPassword: '',
        remarks: ''
      }
    },
    // 关闭变更育成团队长提交弹窗清空
    closeReplaceFormDialog () {
      this.replaceForm = {
        id: this.replaceForm.id,
        salesmanId: '',
        logPhone: '',
        logUserName: '',
        logIdCard: '',
        phone: '',
        userName: '',
        idCard: '',
        password: '',
        checkPassword: '',
        remarks: this.replaceForm.remarks
      }
    },
    // 打开并获取可用来变更育成团队长的业务员列表
    openReplaceTeam (row) {
      let _this = this
      _this.replaceForm.id = row.id
      _this.replaceForm.remarks = row.remarks
      _this.replaceForm.logPhone = row.phone
      _this.replaceForm.logUserName = row.userName
      _this.replaceForm.logIdCard = row.idCard
      _this.openReplaceState = true
      _this.openReplaceLoading = true
      _this.replaceSalesmanList = []
      this.$axios.post('/salesman/replaceSalesmanList', {fosterId: row.fosterId})
        .then((res) => {
          _this.replaceSalesmanList = res.data
          _this.openReplaceLoading = false
        })
    },
    // 提交变更来源业务员
    submitReplaceForm () {
      let _this = this
      if (_this.replaceForm.password.length < 6) {
        return _this.$message.error('请输入长度大于6位的密码！')
      }
      if (_this.replaceForm.password !== _this.replaceForm.checkPassword) {
        return _this.$message.error('两次密码输入不一致！')
      }
      this.$refs['replaceForm'].validate((valid) => {
        if (valid) {
          _this.openReplaceFormLoading = true
          this.$axios.post('/salesman/replaceTeamToSalesman', _this.replaceForm)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.loadData(this.searchForm.type)
                _this.openReplaceFormState = false
                _this.openReplaceState = false
                _this.openReplaceFormLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.openReplaceFormLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    // 关闭变更手机号历史时清空
    closePhoneLogDialog () {
      this.phoneLogList = []
      this.phoneLogName = ''
    },
    // 关闭变更手机号时清空
    closeEditPhoneDialog () {
      this.editPhoneForm = {
        id: '',
        type: '',
        priPhone: '',
        newPhone: '',
        checkNewPhone: ''
      }
    },
    // 打开变更手机号弹窗
    openEditPhone (id, phone, type) {
      this.editPhoneForm.id = id
      this.editPhoneForm.type = type
      this.editPhoneForm.priPhone = phone
      this.openEditPhoneState = true
    },
    // 打开变更手机号历史记录
    getEditPhoneLog (id, type, name) {
      let _this = this
      _this.phoneLogName = name
      _this.phoneLogState = true
      _this.phoneLogLoading = true
      _this.phoneLogList = []
      this.$axios.post('/salesman/getSalesmanPhoneUpdateLog', {id: id, type: type})
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.phoneLogList = res.data
            _this.phoneLogLoading = false
          } else {
            _this.$message.error(res.msg)
            _this.phoneLogLoading = false
          }
        })
    },
    // 提交变更手机号
    submitNewPhone () {
      let _this = this
      if (_this.editPhoneForm.newPhone === '') {
        return _this.$message.error('请输入新手机号！')
      }
      if (_this.editPhoneForm.newPhone !== _this.editPhoneForm.checkNewPhone) {
        return _this.$message.error('两次号码输入不一致！')
      }
      _this.editPhoneLoading = true
      this.$axios.post('/salesman/updatePhone', _this.editPhoneForm)
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            if (_this.editPhoneForm.type === 'team') {
              _this.loadData(this.searchForm.type)
            } else {
              _this.loadSalesmanData(_this.teamId)
            }
            _this.openEditPhoneState = false
            _this.editPhoneLoading = false
          } else {
            _this.$message.error(res.msg)
            _this.editPhoneLoading = false
          }
        })
    },
    // 团队长、业务员资料变更历史关闭清空
    closeUpdateLogDialog () {
      this.updateLogList = []
    },
    // 查看业绩信息时间区间搜索选项
    onDateChange (e) {
      let startDate = new Date(e[0])
      let endDate = new Date(e[1])
      this.achievementForm.startDate = startDate.getFullYear() +
        '-' + (startDate.getMonth() < 10 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) +
        '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
      this.achievementForm.endDate = endDate.getFullYear() +
        '-' + (endDate.getMonth() < 10 ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)) +
        '-' + (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate())
    },
    // 查看业务员业绩信息时间区间搜索选项
    onSalesmanDateChange (e) {
      let startDate = new Date(e[0])
      let endDate = new Date(e[1])
      this.achSalesmanForm.startDate = startDate.getFullYear() +
        '-' + (startDate.getMonth() < 10 ? '0' + (startDate.getMonth() + 1) : (startDate.getMonth() + 1)) +
        '-' + (startDate.getDate() < 10 ? '0' + startDate.getDate() : startDate.getDate())
      this.achSalesmanForm.endDate = endDate.getFullYear() +
        '-' + (endDate.getMonth() < 10 ? '0' + (endDate.getMonth() + 1) : (endDate.getMonth() + 1)) +
        '-' + (endDate.getDate() < 10 ? '0' + endDate.getDate() : endDate.getDate())
    },
    // 头部选项
    searchCooperator (item) {
      if (this.searchForm.cooperatorId === item.value) {
        return
      }
      this.form.parentId = item.value
      this.selectedName = item.name
      this.searchForm.cooperatorId = item.value
      this.loadData('1')
    },
    // 列表中打开所属业务员列表
    rowClick (row) {
      let rowId = row.id
      // eslint-disable-next-line no-extend-native
      Array.prototype.remove = function (val) {
        let index = this.indexOf(val)
        if (index > -1) {
          this.splice(index, 1)
        }
      }
      if (this.expands.indexOf(rowId) < 0) {
        this.expands = [rowId]
        this.salesmanPageNo = 1
        this.salesmanListContent = ''
        this.loadSalesmanData(rowId)
        this.teamId = rowId
      } else {
        this.expands = []
        this.salesmanList = []
        this.teamId = ''
        this.salesmanListContent = ''
      }
    },
    // 业务员分页
    handleCurrentSalesmanChange (val) {
      this.salesmanPageNo = val
      this.loadSalesmanData(this.teamId)
    },
    openDialog () {
      this.openState = true
      if (this.searchForm.type === '1') {
        this.formTitle = '团队长'
      } else if (this.searchForm.type === '2') {
        this.formTitle = '特派员'
      }
    },
    // 打开业务员弹窗新增
    openSalesmanDialog (teamId, userName) {
      this.salesmanTitle = userName + '-业务员'
      this.salesmanForm.teamId = teamId
      this.openSalesmanState = true
    },
    // 关闭业务员弹窗清空
    closeSalesmanDialog () {
      this.salesmanForm = {
        id: '',
        teamId: '',
        phone: '',
        userName: '',
        idCard: '',
        password: '',
        checkPhone: '',
        checkUserName: '',
        checkIdCard: '',
        checkPassword: '',
        remarks: ''
      }
      this.isEdit = false
    },
    // 关闭团队长、特派员弹窗清空
    closeDialog () {
      this.form = {
        id: '',
        parentId: this.searchForm.cooperatorId,
        phone: '',
        userName: '',
        idCard: '',
        password: '',
        checkPhone: '',
        checkUserName: '',
        checkIdCard: '',
        checkPassword: '',
        userType: '',
        remarks: ''
      }
      this.isEdit = false
    },
    // 关闭升级团队长弹窗清空数据
    closeFosterDialog () {
      this.fosterForm = {
        parentId: '',
        fosterId: '',
        toFosterId: '',
        phone: '',
        userName: '',
        idCard: '',
        password: '',
        checkPassword: '',
        userType: '',
        remarks: ''
      }
    },
    // 关闭查看业绩初始化数据
    closeAchievementDialog () {
      this.achievement = {
        fosterAllMoney: 0,
        fosterNum: 0,
        fosterSalesmanNum: 0,
        fosterUserNum: 0,
        teamAllMoney: 0,
        teamSalesmanNum: 0,
        teamUserNum: 0
      }
      this.achievementForm = {
        teamId: '',
        startDate: '',
        endDate: ''
      }
      this.achievementDateArr = []
    },
    loadSearch () {
      this.total = 0
      this.searchForm.pageNo = 1
      this.loadData(this.searchForm.type)
    },
    // 重置搜索
    resetSearch () {
      this.searchForm = {
        userType: this.userType,
        cooperatorId: this.searchForm.cooperatorId,
        phone: '',
        userName: '',
        type: '1',
        pageNo: 1
      }
      this.salesmanPhone = []
      this.salesmanListContent = ''
      this.loadData(this.searchForm.type)
    },
    // 团队长、特派员分页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.loadData(this.searchForm.type)
    },
    // 编辑团队长业务员
    openForm (row) {
      if (this.searchForm.type === '1') {
        this.formTitle = '变更团队长资料'
      } else if (this.searchForm.type === '2') {
        this.formTitle = '变更特派员资料'
      }
      this.form.id = row.id
      this.form.parentId = row.cooperatorId
      this.form.phone = row.phone
      this.form.userName = row.userName
      this.form.idCard = row.idCard
      this.form.userType = this.userType
      this.form.remarks = row.remarks
      this.isEdit = true
      this.openState = true
    },
    // 编辑业务员
    editSalesman (row) {
      this.salesmanTitle = '编辑-' + row.userName
      this.isEdit = true
      this.salesmanForm.id = row.id
      this.salesmanForm.teamId = row.teamId
      this.salesmanForm.phone = row.phone
      this.salesmanForm.userName = row.userName
      this.salesmanForm.idCard = row.idCard
      this.salesmanForm.remarks = row.remarks
      this.openSalesmanState = true
    },
    // 打开育成团队长新增窗口
    openFoster (row) {
      this.fosterForm = {
        parentId: this.searchForm.cooperatorId,
        fosterId: row.teamId,
        toFosterId: row.id,
        phone: row.phone,
        userName: row.userName,
        idCard: row.idCard,
        password: '',
        checkPassword: '',
        userType: this.userType,
        remarks: ''
      }
      this.openFosterState = true
    },
    // 保存团队长，特派员
    submit () {
      let _this = this
      if (_this.isEdit === false && _this.form.phone.length === 0) {
        return _this.$message.error('请输入电话！')
      }
      if (_this.isEdit === false && _this.form.phone !== _this.form.checkPhone) {
        return _this.$message.error('两次电话输入不一致！')
      }
      if (_this.form.userName !== _this.form.checkUserName) {
        return _this.$message.error('两次姓名输入不一致！')
      }
      if (_this.form.idCard !== _this.form.checkIdCard) {
        return _this.$message.error('两次身份证号码输入不一致！')
      }
      if (_this.isEdit === false && _this.form.password.length === 0) {
        return _this.$message.error('请输入密码！')
      }
      if (_this.form.password !== _this.form.checkPassword) {
        return _this.$message.error('两次密码输入不一致！')
      }
      _this.form.userType = this.userType
      let params = {
        id: _this.form.id,
        parentId: _this.form.parentId,
        phone: _this.form.phone,
        userName: _this.form.userName,
        idCard: _this.form.idCard,
        password: _this.form.password,
        userType: _this.form.userType,
        remarks: _this.form.remarks
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          _this.formLoading = true
          let path = _this.searchForm.type === '1' ? '/salesman/saveTeam' : '/salesman/saveSpecial'
          this.$axios.post(path, params)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.loadData(this.searchForm.type)
                _this.openState = false
                _this.formLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.formLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    // 新增育成团队长
    submitFoster () {
      let _this = this
      if (_this.fosterForm.password.length < 6) {
        return _this.$message.error('请输入长度大于6位的密码！')
      }
      if (_this.fosterForm.password !== _this.fosterForm.checkPassword) {
        return _this.$message.error('两次密码输入不一致！')
      }
      this.$refs['fosterForm'].validate((valid) => {
        if (valid) {
          _this.fosterFormLoading = true
          this.$axios.post('/salesman/addFosterTeam', _this.fosterForm)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.loadData(this.searchForm.type)
                _this.openFosterState = false
                _this.fosterFormLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.fosterFormLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    // 查看变更记录
    getSalesmanUpdateLog (id, type) {
      let _this = this
      _this.updateLogState = true
      _this.updateLogLoading = true
      _this.updateLogList = []
      this.$axios.post('/salesman/getSalesmanUpdateLog', {id: id, type: type})
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.updateLogList = res.data
            _this.updateLogLoading = false
          } else {
            _this.$message.error(res.msg)
            _this.updateLogLoading = false
          }
        })
    },
    // 查看育成团队长变更记录
    getReplaceTeamLog (teamId) {
      let _this = this
      _this.replaceTeamLogState = true
      _this.replaceTeamLogLoading = true
      _this.replaceTeamLogList = []
      this.$axios.post('/salesman/getReplaceTeamLog', {teamId: teamId})
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.replaceTeamLogList = res.data
            _this.replaceTeamLogLoading = false
          } else {
            _this.$message.error(res.msg)
            _this.replaceTeamLogLoading = false
          }
        })
    },
    // 查看育成团队长上下级信息
    getParentTeamAndSonTeam (id, fosterId) {
      let _this = this
      _this.parentTeamState = true
      _this.parentTeamLoading = true
      _this.parentTeam = {}
      _this.sonTeamList = []
      this.$axios.post('/salesman/getParentTeamAndSonTeam', {id: id, fosterId: fosterId})
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            if (res.data.parentTeam !== null) {
              _this.parentTeam.phone = res.data.parentTeam.phone
              _this.parentTeam.userName = res.data.parentTeam.userName
              _this.parentTeam.idCard = res.data.parentTeam.idCard
            }
            if (res.data.sonTeamList !== null && res.data.sonTeamList.length > 0) {
              _this.sonTeamList = res.data.sonTeamList
            }
            _this.parentTeamLoading = false
          } else {
            _this.$message.error(res.msg)
            _this.parentTeamLoading = false
          }
        })
    },
    // 查看团队长业绩
    openAchievement (id, teamName) {
      let _this = this
      _this.teamName = teamName
      _this.achievementForm.teamId = id
      _this.openAchievementState = true
      _this.openAchievementLoading = true
      this.$axios.post('/salesman/lookTeamAchievement', _this.achievementForm)
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.achievement = res.data
            _this.openAchievementLoading = false
          } else {
            _this.$message.error(res.msg)
            _this.openAchievementLoading = false
          }
        })
    },
    // 查看业务员业绩
    openSalesmanAchievement (id, teamId, salesmanName) {
      let _this = this
      _this.salesmanName = salesmanName
      _this.achSalesmanForm.id = id
      _this.achSalesmanForm.teamId = teamId
      _this.openAchSalesmanState = true
      _this.openAchSalesmanLoading = true
      this.$axios.post('/salesman/lookSalesmanAchievement', _this.achSalesmanForm)
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.achSalesmanNum = res.data
            _this.openAchSalesmanLoading = false
          } else {
            _this.$message.error(res.msg)
            _this.openAchSalesmanLoading = false
          }
        })
    },
    // 保存业务员
    submitSalesman () {
      let _this = this
      if (_this.isEdit === false && _this.salesmanForm.phone.length === 0) {
        return _this.$message.error('请输入电话！')
      }
      if (_this.isEdit === false && _this.salesmanForm.phone !== _this.salesmanForm.checkPhone) {
        return _this.$message.error('两次电话输入不一致！')
      }
      if (_this.salesmanForm.userName !== _this.salesmanForm.checkUserName) {
        return _this.$message.error('两次姓名输入不一致！')
      }
      if (_this.salesmanForm.idCard !== _this.salesmanForm.checkIdCard) {
        return _this.$message.error('两次身份证号码输入不一致！')
      }
      if (_this.isEdit === false && _this.salesmanForm.password.length === 0) {
        return _this.$message.error('请输入密码！')
      }
      if (_this.salesmanForm.password !== _this.salesmanForm.checkPassword) {
        return _this.$message.error('两次密码输入不一致！')
      }
      let params = {
        id: _this.salesmanForm.id,
        teamId: _this.salesmanForm.teamId,
        phone: _this.salesmanForm.phone,
        userName: _this.salesmanForm.userName,
        idCard: _this.salesmanForm.idCard,
        password: _this.salesmanForm.password,
        remarks: _this.salesmanForm.remarks
      }
      this.$refs['salesmanForm'].validate((valid) => {
        if (valid) {
          _this.salesmanFormLoading = true
          this.$axios.post('/salesman/saveSalesman', params)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.loadSalesmanData(this.salesmanForm.teamId)
                _this.openSalesmanState = false
                _this.salesmanFormLoading = false
              } else {
                _this.$message.error(res.msg)
                _this.salesmanFormLoading = false
              }
            })
        } else {
          return false
        }
      })
    },
    // 团队长，特派员列表
    loadData (type) {
      let _this = this
      _this.expands = []
      _this.salesmanList = []
      _this.teamId = ''
      _this.isLoading = true
      _this.searchForm.type = type
      _this.searchForm.userType = _this.userType
      _this.list = []
      this.$axios.post('/salesman/list', _this.searchForm)
        .then((res) => {
          _this.list = res.data.rows
          _this.total = res.data.total
          _this.isLoading = false
        })
    },
    // 业务员列表
    loadSalesmanData (id) {
      let _this = this
      _this.isSalesmanLoading = true
      _this.salesmanList = []
      this.$axios.post('/salesman/salesmanList', {teamId: id, phone: _this.salesmanListContent, pageNo: _this.salesmanPageNo})
        .then((res) => {
          _this.salesmanList = res.data.rows
          _this.salesmanTotal = res.data.total
          _this.isSalesmanLoading = false
        })
    },
    loadSalesmanSearch (teamId) {
      this.salesmanTotal = 0
      this.salesmanPageNo = 1
      this.loadSalesmanData(teamId)
    },
    // 刷新业务员列表
    refreshSalesmanData () {
      this.salesmanTotal = 0
      this.salesmanListContent = ''
      this.loadSalesmanData(this.teamId)
    },
    // 获取业务员所属队长信息
    loadSalesmanInfo () {
      let _this = this
      if (_this.salesmanPhone.length !== 11) {
        _this.$message.error('请填写正确的电话号码。')
        return
      }
      _this.isSalesmanTeamInfoLoading = true
      // 查询之前清空内容，判断是否显示
      _this.salesmanTeamInfo = {
        phone: '',
        name: '',
        coopRemarks: ''
      }
      this.$axios.post('/salesman/salesmanTeamInfoByPhone', {phone: _this.salesmanPhone, userType: _this.userType})
        .then((res) => {
          if (res.status === 200) {
            if (res.data !== null) {
              _this.salesmanTeamInfo = res.data
            } else {
              _this.$message.error('未查到信息。')
            }
            _this.isSalesmanTeamInfoLoading = false
          } else {
            _this.$message.error(res.msg)
            _this.isSalesmanTeamInfoLoading = false
          }
        })
    },
    // 城市合作商下拉选项
    loadCooperatorOpt () {
      let _this = this
      this.$axios.post('/options/cooperatorOpt')
        .then((res) => {
          _this.cooperatorOpt = res.data
          this.searchForm.cooperatorId = res.data[0].value
          this.form.parentId = res.data[0].value
          this.selectedName = res.data[0].name
          this.loadData('1')
        })
    }
  },
  mounted () {
    if (!window.sessionStorage.user) {
      this.$router.push({name: 'login'})
    } else {
      this.userType = JSON.parse(window.sessionStorage.user).userType
    }
    this.loadData('1')
    // 如果是省级合作商则加载省内城市合作商列表，否则直接加载团队长列表
    if (this.userType === '1') {
      this.loadCooperatorOpt()
    }
  }
}
</script>

<style>
.el-table__expand-icon {
  display: none;
}

.m-to-salesmanStructure {
  position: absolute;
  z-index: 1;
  top: 72px;
  left: 5px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.salesman-box {
  padding: 20px 60px;
  box-sizing: border-box;
  background-color: #fff2de;
}

.salesman-bg {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
}

.salesman-head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
}

.salesman-tit {
  color: #0084ff;
  font-size: 16px;
  display: flex;
  align-items: end;
}

.m-title-head {
  padding: 0 30px 10px 0;
  display: flex;
}

.m-title-left {
}

.m-title-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  padding-left: 30px;
}

.m-table-tips {
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -115px;
  width: 230px;
  text-align: center;
  font-size: 16px;
  border: 1px solid #ff4d51;
  padding: 4px 0 4px 0;
  border-radius: 5px;
  color: #ffffff;
  background-color: #f56c6c;
}

.top-option-item {
  padding: 0 30px 0 30px;
  height: 35px;
  border: 1px solid #f56c6c;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor:pointer;
}

.top-option-item:active {
  background-color: #fdaaaa;
  color: #ffffff;
}

.top-option-this {
  background-color: #f56c6c;
  color: #ffffff;
}

.m-team-info {
  border: 1px solid #ff4d51;
  border-radius: 4px;
  margin: 0 0 20px 0;
  padding: 10px 10px 0 10px;
}

.parent-team-box {
  font-weight: bold;
  border: 1px solid #ececec;
}

.parent-team-team-t {
  text-align: center;
  border-bottom: 1px solid #ececec;
  padding: 10px;
  color: #3a8ee6;
}

.parent-team-team-n {
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

.parent-team-bott-t {
  text-align: center;
  font-weight: bold;
  border-top: 1px solid #ececec;
  border-left: 1px solid #ececec;
  border-right: 1px solid #ececec;
  padding: 10px;
  margin: 20px 0 0 0;
  color: #5daf34;
}
.ach-box {
  margin-bottom: 20px;
  border: 1px solid #dedede;
  border-radius: 5px;
}
.ach-top {
  border-bottom: 1px solid #dedede;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}
.ach-item {
  text-align: center;
  padding: 30px 0 30px 0;
  font-weight: bold;
  font-size: 18px;
}
.ach-item-money {
  width: 30%;
  text-align: center;
  padding: 30px 0 0 0;
  font-weight: bold;
  font-size: 18px;
}
.num-color {
  color: #ff4d51;
}
.ach-top-col {
  color: #3a8ee6;
}
</style>



// WEBPACK FOOTER //
// src/components/salesman/Salesman.vue